/**
 * Tujuan: Footer global — copyright, social links
 * Caller: App.js (rendered on every page)
 * Dependensi: react-icons
 * Main Functions: Footer()
 * Side Effects: None
 */
import React from "react";
import { AiFillGithub, AiOutlineInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">

        <div className="footer-text">
          Hosted on my potato PC
        </div>

        <div className="footer-text footer-center">
          Copyright &copy; 2026 Nabilah Putri
        </div>

        <div className="footer-social">
          <a href="https://github.com/nabilahintaka" target="_blank" rel="noreferrer" aria-label="GitHub">
            <AiFillGithub />
          </a>
          <a href="https://www.linkedin.com/in/nabilahintaka/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <FaLinkedinIn />
          </a>
          <a href="https://www.instagram.com/nabilahintaka/" target="_blank" rel="noreferrer" aria-label="Instagram">
            <AiOutlineInstagram />
          </a>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
